module.exports = __webpack_public_path__ + "img/utility-pill-bg-3.0c691477.png";